import { FC, memo, useState } from 'react';
import { S3_URL } from 'constants/index';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { Button, Image, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useAuthStore from 'store/auth';
import { useFollowCompanyMutation } from 'services';
import toast from 'react-hot-toast';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const CompanyDetailsBox: FC<any> = ({ company, handleClick }) => {
	const { translate } = useTranslate();
	const navigate = useNavigate();
	const { user: authUser }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	const { mutateAsync: followCompanyMutation } = useFollowCompanyMutation();
	const [followStatus, setFollowStatus] = useState(company?.isCompanyFollow || false);

	const followCompany = () => {
		followCompanyMutation({ id: company?.companyId })
			.then((res: any) => {
				if (res?.success) {
					setFollowStatus((prev: any) => !prev);
				}
			})
			.catch((error) => {
				console.error('Failed to follow company:', error);
				toast.error(
					translate('ToastMessage.failedToFollowTitle', { title: translate('Social.company') }),
				); // Notify the user of the failure
			});
	};

	const handleViewProfileBtnClick = (evt: any) => {
		evt.stopPropagation();
		const isLoggedIn = handleClick();
		if (isLoggedIn) navigate(`/company/profile/${company?.companyId}`);
	};

	return (
		<div className="company-follow-card d-flex flex-column flex-md-row align-items-md-center gap-3">
			<div className="d-flex align-items-md-center flex-1 gap-3">
				<div className="company-follow-card-logo">
					<Image
						src={
							company?.companyLogo
								? `${S3_URL}${company.companyLogo}`
								: IMAGE_PATHS.CompanyLogoDefault
						}
						alt="logo"
						className="w-100 h-100 object-fit-cover"
						loading="lazy"
					/>
				</div>
				<Stack className="company-follow-card-detail justify-content-center flex-1 gap-2">
					{company?.companyName && <h4 className="mb-0 fw-bold">{company.companyName}</h4>}
					{company?.title && <p className="company-type mb-0">{company.title}</p>}
					{company?.companyFoundedYear > 0 ? (
						<p className="company-founded mb-0">
							{translate('Profile.foundedIn')} {company.companyFoundedYear}
						</p>
					) : (
						''
					)}
				</Stack>
			</div>
			<div className="company-follow-card-actions d-flex flex-md-column gap-2 gap-xl-3">
				<Button
					onClick={(evt) => handleViewProfileBtnClick(evt)}
					className="transparent-btn rounded-pill"
				>
					{translate('Header.viewProfile')}
				</Button>
				{(company?.companyId !== authUser?.userId || !authUser?.userId) && (
					<Button
						onClick={() => (authUser?.userId ? followCompany() : handleClick())}
						className="filled-btn rounded-pill"
					>
						{followStatus ? translate('Common.unFollow') : translate('Common.follow')}
					</Button>
				)}
			</div>
		</div>
	);
};

export default memo(CompanyDetailsBox);
